import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
// import GetDocsRight from "../components/Doctors/departments/section-left";
import GetDocsLeft from "../components/Doctors/departments/section-right";
import SEO from "../components/SEO";

const PageAbout = (props) => {
  return (
    <Fragment>
      <Header />
      <PageHeader
        bgImg={require("../assets/img/doctors-bg.jpg")}
        title="Doctors in our Fertility Center"
        content=""
      />
      <SEO />
      <GetDocsLeft
        hospitals="kcfer"
        deptTitle="Fertility and IVF"
        dept="infertility_and_ivf"
        image="separator14.svg"
      />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default PageAbout;
